
import param from '~/utils/url/param.js'
export default {
  name: 'social-whatsapp',
  props: {
    url: {
      type: String,
      async default() {
        return await window.location.href
      }
    },
    title: { type: String, default: '' }
  },
  data() {
    return {
      separator: ' '
    }
  },
  methods: {
    open() {
      window.open(
        'https://api.whatsapp.com/send' +
          param({
            text: this.title ? this.title + this.separator + this.url : this.url
          }),
        '__blank'
      )
    }
  }
}
